import { sdkRequest } from '@eb/http';

export const fetchExpandedCollections = async (eventId: string) => {
    const data = await sdkRequest(
        `/api/v3/events/${eventId}/collections/?expand=organizer,image,event_count`,
    );

    return data;
};
